import { render } from "./B2bFilterButtonAuditoriaAcciones.vue?vue&type=template&id=97a14efe&scoped=true&lang=pug"
import script from "./B2bFilterButtonAuditoriaAcciones.vue?vue&type=script&lang=js"
export * from "./B2bFilterButtonAuditoriaAcciones.vue?vue&type=script&lang=js"

import "./B2bFilterButtonAuditoriaAcciones.vue?vue&type=style&index=0&id=97a14efe&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97a14efe"]])

export default __exports__